import React from "react";
import styles from "./index.module.scss";
import letter from "./icon.png";
export var Details = function () {
    return React.createElement("div", { className: styles.container },
        React.createElement("div", { className: "title" }, "En d\u00E9tails"),
        React.createElement("div", { className: styles.text },
            "Le grand jour se profile \u00E0 l\u2019horizon... nous nous marierons le samedi 17 d\u00E9cembre 2022, et nous nous dirons oui \u00E0 11 heures. C'est avec joie que nous vous invitons \u00E0 venir partager notre bonheur lorsque nous \u00E9changerons nos promesses d'amour et de fid\u00E9lit\u00E9.",
            React.createElement("br", null),
            React.createElement("br", null),
            "Nous comptons sur votre pr\u00E9sence pour cet \u00E9v\u00E8nement qui sera riche en \u00E9motions et marquera un tournant dans nos vies.",
            React.createElement("br", null),
            React.createElement("br", null),
            "La suite des festivit\u00E9s se poursuivra en d\u00E9but d'apr\u00E8s-midi \u00E0 partir de 14h, o\u00F9 nous nous retrouverons pour une petite r\u00E9ception dans le restaurant ",
            React.createElement("a", { href: "https://www.instagram.com/lemyrha", target: "blank" }, "Le Myrha"),
            " (70 Rue Myrha, 75018 Paris). Tous les mets les plus exquis de vos convoitises vous y attendront."),
        React.createElement("img", { src: letter, className: styles.letter }));
};
